import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import SessionCard from "../components/SessionCard";
import { ShoppingBag } from "lucide-react";

export default function Library() {
  const [items, setItems] = useState([]);
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { api.get("/library").then(({ data }) => setItems(data.items)); }, []);
  const [filter, setFilter] = useState("all");
  const filters = ["all", ...new Set(items.flatMap((i) => [i.kind === "personalized" ? "custom" : i.type, ...(i.tags || [])]).filter(Boolean))];
  const shown = items.filter((i) => filter === "all" || (filter === "custom" ? i.kind === "personalized" : i.type === filter || (i.tags || []).includes(filter)));

  return (
    <div className="relative flex-1 overflow-y-auto mm-scroll bg-white" data-testid="library-page">
      <div className="sticky top-0 z-20 bg-white/95 backdrop-blur-md border-b border-slate-100 px-5 py-4 flex items-center justify-between">
        <div>
          <h1 className="font-serif text-2xl font-bold text-navy">Library</h1>
          <p className="text-xs text-slate-500">{items.length} sessions unlocked · replays are free</p>
        </div>
        <button data-testid="library-buy-btn" onClick={() => navigate("/paywall")}
          className="flex items-center gap-1.5 bg-royal/10 text-royal font-semibold text-sm px-3 py-2 rounded-full">
          <ShoppingBag size={15} /> {user?.credits || 0}
        </button>
      </div>

      <div className="px-5 py-4 space-y-3">
        {filters.length > 1 && (
          <div className="flex gap-2 overflow-x-auto mm-scroll pb-1 -mx-1 px-1" data-testid="library-filters">
            {filters.map((f) => (
              <button key={f} data-testid={`library-filter-${f}`} onClick={() => setFilter(f)}
                className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-semibold border capitalize transition ${filter === f ? "bg-navy text-white border-navy" : "bg-white text-slate-600 border-slate-200"}`}>
                {f}
              </button>
            ))}
          </div>
        )}
        {shown.length === 0 && (
          <p className="text-center text-slate-400 py-16">Your unlocked sessions will appear here.</p>
        )}
        {shown.map((item) => (
          <div key={item.id} className="animate-fade-up"><SessionCard item={item} /></div>
        ))}
      </div>
    </div>
  );
}
